import React, { useState, useEffect } from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../AppContext';

const QuestJournal = () => {
  const { t } = useTranslation();
  const { currentUserProfile } = useAppContext();
  const [completedQuests, setCompletedQuests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (currentUserProfile && currentUserProfile.completedQuests) {
      const journalEntries = Object.entries(currentUserProfile.completedQuests)
        .map(([questId, timestamp]) => ({
          id: questId,
          title: questId.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()), // Basic title from ID
          completionDate: timestamp.toDate().toLocaleDateString(),
          lore: t('questJournal.lorePlaceholder', { questName: questId.replace(/_/g, ' ') }),
        }))
        .sort((a, b) => new Date(b.completionDate) - new Date(a.completionDate)); // Sort by newest first
      setCompletedQuests(journalEntries);
      setIsLoading(false);
    }
  }, [currentUserProfile, t]);

  if (isLoading) {
    return <div className="text-center p-8 text-white">{t('questJournal.loading')}</div>;
  }

  if (completedQuests.length === 0) {
    return (
      <div className="text-center text-gray-400 italic py-8">
        <LucideIcons.BookOpen size={48} className="mx-auto mb-4" />
        <p>{t('questJournal.empty')}</p>
      </div>
    );
  }

  return (
    <div className="animate-fadeIn space-y-6">
      <h3 className="text-xl font-bold mb-4 text-blue-200 font-playfair text-center">{t('questJournal.title')}</h3>
      {completedQuests.map(entry => (
        <div key={entry.id} className="bg-gray-800/50 p-4 rounded-lg border border-gray-700 shadow-lg">
          <h4 className="font-bold text-white text-lg mb-1">{entry.title}</h4>
          <p className="text-xs text-gray-400 mb-2">{t('questJournal.completedOn', { date: entry.completionDate })}</p>
          <p className="text-sm text-gray-300 italic">{entry.lore}</p>
        </div>
      ))}
    </div>
  );
};

export default QuestJournal;
